import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {getServiceActivities} from "../../services/service/service_activity";
import {ServiceContext} from "./service_context";
import FileCell from "../system/fileViewer";

export function ServiceActivities() {

  const {
    service,
    modalOpen,
    setModalOpen,
    lastDataRefresh,
    setLastDataRefresh,
    from,
    setStep
  } = useContext(ServiceContext);

  const disable = service.status === "finish"

  const handleOpen = () => setModalOpen(!modalOpen);

  const [serviceActivities, setServiceActivities] = useState({});


  useEffect(() => {
    async function getData() {
      const result = await getServiceActivities(service.id);
      if (result.status === 200) {
        const {serviceActivitiesList} = result.data;
        setServiceActivities(serviceActivitiesList || []);
      }
    }

    if (service.id) {
      getData()
    }
  }, [service, lastDataRefresh]);

  if (serviceActivities.length > 0) {
    return (
      <Dialog size="xl" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen overflow-y-scroll mt-20 mb-20">
        <DialogHeader className="border-b">
          {from === "person" &&
            <Typography>
              {"گزارش پیشرفت خدمات" + " - " + service.agent_name + " " + service.agent_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          }
          {from === "agent" &&
            <Typography>
              {"گزارش پیشرفت خدمات" + " - " + service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          }
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">
          {from === "agent" && !disable &&
            <div className="flex flex-row justify-end mb-4">
              <Button className="" onClick={() => {
                setStep("action");
              }} variant="outlined">ثبت عملیات جدید</Button>
            </div>}
          <>
            {serviceActivities.map(
              ({type, meta_text, description, file, created_at}, index) => {
                return (
                  <Card color="transparent" shadow={false} className="p-2 w-full   border-2 mb-2">
                    <CardHeader
                      color="transparent"
                      floated={false}
                      shadow={false}
                      className="mx-0 flex items-center gap-4 pt-0 pb-8"
                    >
                      <div className="flex w-full flex-row justify-between gap-2">
                        <div className="flex items-center justify-between">
                          <Chip
                            variant="ghost"
                            color={type === "file_accepted" ? "teal" :
                              type === "file_rejected" ? "red" :
                                type === "file_new" ? "cyan" :
                                  type === "file_upload" ? "purple" :
                                    type === "price" || type === "payment" || type === "day" ? "blue" :
                                      type === "start" || type === "ready_for_payment" ? "amber" :
                                        type === "action" ? "indigo" :
                                          "red"}
                            size="sm"
                            value={Dict(`${type}`)}
                          />
                        </div>
                        <Typography>{persianNumberFormat(created_at)}</Typography>
                      </div>
                    </CardHeader>
                    <CardBody className="-mt-4 mb-2 p-0">
                      <Typography color="blue-gray">
                        {!meta_text && Dict("type_" + type)}
                        {meta_text && type !== "price" && type !== "payment" && type !== "day" && Dict("type_" + type).replace("*", meta_text)}
                        {(meta_text && type === "price" || type === "payment" || type === "day") && Dict("type_" + type).replace("*", persianNumberFormat(meta_text, true))}

                        {description?.length > 0 &&
                          <Typography className="font-light" color="blue-gray">
                            {`توضیحات: ${description}`}
                          </Typography>
                        }
                      </Typography>
                      {file &&
                        <div className="mb-4">
                          <FileCell
                            label={Dict('file')}
                            fileCode={file}
                          />
                        </div>
                      }
                    </CardBody>
                  </Card>
                )
              }
            )}
          </>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={() => {
            handleOpen()
          }}>
            <span>بستن</span>
          </Button>
        </DialogFooter>
      </Dialog>
    )
  }
}